import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function DownArrow(props:any) {
	
	return (
	
		<SvgIcon width="12" height="8" fontSize="inherit" viewBox="0 0 12 8">
			<path d="M1.41 8L6 3.05533L10.59 8L12 6.47773L6 0L0 6.47773L1.41 8Z" fill="currentColor"/>
		</SvgIcon>
	
	)
}
